import { useTranslation } from 'next-i18next';
import React, { ReactElement, useRef } from 'react';
import { BsLink } from '@hotelplan/core.basis.bs-link';
import { useToggleState } from '@hotelplan/libs.hooks-react';
import { trackSearch } from '@hotelplan/libs.tracking';
import { mapSearchControlStateToTrackableData } from 'fdr/components/candidate/fdr-search/mappers/fdr-search-control.mappers';
import { EThemeFormPageType } from 'fdr/components/local/fdr-theme/fdr-theme.types';
import FdrThemeSearchForm from './fdr-theme-search-form';
import {
  FdrThemeSearchControlToggler,
  FdrThemeSearchControlWrapper,
} from './fdr-theme-search-form.styles';

interface IFdrThemeFormActionTogglerProps {
  pageType: EThemeFormPageType;
  id?: string;
}

export function FdrThemeFormActionToggler({
  pageType,
  id,
}: IFdrThemeFormActionTogglerProps): ReactElement {
  const { t } = useTranslation('theme');

  const searchControlEl = useRef<HTMLDivElement>(null);
  const [isSearchControlShowed, showSearchControl, closeSearchControl] =
    useToggleState(false);

  return (
    <FdrThemeSearchControlWrapper ref={searchControlEl}>
      {isSearchControlShowed ? (
        <FdrThemeSearchForm
          id={id}
          pageType={pageType}
          handleCancel={closeSearchControl}
          postSubmit={function (state) {
            trackSearch({
              searchControl: mapSearchControlStateToTrackableData(state),
            });
          }}
        />
      ) : (
        <FdrThemeSearchControlToggler>
          <BsLink
            className="search-control-link"
            href="#"
            onClick={e => {
              e.preventDefault();
              showSearchControl();
            }}
          >
            {t('startSearch.button')}
          </BsLink>
        </FdrThemeSearchControlToggler>
      )}
    </FdrThemeSearchControlWrapper>
  );
}
